import { TokenApi } from './token';

export const token = new TokenApi();
